import { motion, Variants } from "framer-motion";
import { useContext } from "react";
import { TimelineAnimateScrollContext } from "../../context/TimlineAnimateScrollContext";

interface TimelineScrollFadeProps {}

const aniScrollVariants: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

export const TimelineScrollFade: React.FC<TimelineScrollFadeProps> = ({
  children,
}) => {
  const {
    state: { isAnimating },
  } = useContext(TimelineAnimateScrollContext);

  return (
    <motion.div
      variants={aniScrollVariants}
      animate={isAnimating ? "hidden" : "visible"}
      transition={{ duration: 0.5 }}
    >
      {children}
    </motion.div>
  );
};
